export default "__VITE_ASSET__D5v1P$hu__"